import React from 'react';
import { SectionHeader } from '@naf-simba/sections-headers';
import { StandardHeaderProps } from './SectionPageHeader.types';

export const StandardHeader = ({ title, ingress, imageOrVideo }: StandardHeaderProps) => (
  <SectionHeader
    title={title}
    ingress={ingress}
    imageOrVideo={imageOrVideo}
    // Legacy spruce-header layout: image stacked below the text on tablet,
    // beside only at desktop (≥992). Matches prod's SectionPage header.
    imageBelow
  />
);
